import axios from "axios";
import { useMemo, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function errMsg(e, fallback = "Something went wrong") {
  return e?.response?.data?.detail || e?.message || fallback;
}

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const client = axios.create({ baseURL: API });
    client.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    client.stream = async (path, body, onText) => {
      const t = await getToken();
      const res = await fetch(`${API}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${t}` },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        let msg = "The AI writer could not start";
        try { const j = await res.json(); msg = typeof j.detail === "string" ? j.detail : msg; } catch {}
        throw new Error(msg);
      }
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "", full = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          const line = p.replace(/^data: /, "").trim();
          if (!line) continue;
          if (line === "[DONE]") return full;
          const ev = JSON.parse(line);
          if (ev.error) throw new Error(ev.error);
          full += ev.t;
          onText(full);
        }
      }
      return full;
    };
    return client;
  }, [getToken]);
}

export function useMe() {
  const api = useApi();
  const [me, setMe] = useState(null);
  useEffect(() => {
    api.get("/me").then((r) => setMe(r.data)).catch(() => setMe(null));
  }, [api]);
  return me;
}
